<ngx-spinner></ngx-spinner>
<div class="container">
  <h1>Agendar - registra los siguientes datos para agendar la videollamada</h1>
  <h3>* Campos obligatorios</h3>
  <div class="mat-elevation-z8">
    <div style="padding: 1%;">
      <form class="form" [formGroup]="formulario" (ngSubmit)="openDialog()">
        <mat-form-field class="full-width">
          <mat-label>&nbsp; * Nombre Completo</mat-label>
          <textarea matInput formControlName="nombre"></textarea>
        </mat-form-field>
        <h4>Sexo</h4>
        <mat-radio-group aria-label="Select an option" formControlName="sexo">
          <mat-radio-button value="1">Mujer</mat-radio-button>
          <mat-radio-button value="2">Hombre</mat-radio-button>
        </mat-radio-group>
        <br>
        <br>
        <mat-form-field class="full-width">
          <mat-label>Nombre de la empresa (si es el caso)</mat-label>
          <textarea matInput formControlName="empresa"></textarea>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>* Entidad Federativa</mat-label>
          <mat-select formControlName="entidad">
            <mat-option *ngFor="let entidad of entidades" [value]="entidad.id">{{entidad.descripcion}}</mat-option>
          </mat-select>
        </mat-form-field>
        <h4>Último grado de escolaridad</h4>
        <mat-radio-group aria-label="Select an option" class="escolaridad" formControlName="estudios">
          <mat-grid-list [cols]="breakpoint" rowHeight="2:0.5" (window:resize)="onResize($event)">
            <mat-grid-tile><mat-radio-button value="1">Maestría/Doctorado</mat-radio-button></mat-grid-tile>
            <mat-grid-tile><mat-radio-button value="2">Licenciatura</mat-radio-button></mat-grid-tile>
            <mat-grid-tile><mat-radio-button value="3">Preparatoria</mat-radio-button></mat-grid-tile>
            <mat-grid-tile><mat-radio-button value="4">Secundaria</mat-radio-button></mat-grid-tile>
            <mat-grid-tile><mat-radio-button value="5">Primaria</mat-radio-button></mat-grid-tile>
            <mat-grid-tile><mat-radio-button value="6">Ninguno</mat-radio-button></mat-grid-tile>
          </mat-grid-list>
        </mat-radio-group>
        <br>
        <mat-form-field appearance="fill">
          <mat-label>* Ocupación actual</mat-label>
          <mat-select formControlName="ocupacionActual">
            <mat-option *ngFor="let ocupacion of ocupacionActual" [value]="ocupacion.id">{{ocupacion.descripcion}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-form-field class="full-width">
          <mat-label>&nbsp;&nbsp; * Teléfono</mat-label>
          <textarea matInput formControlName="telefono" placeholder="Número de teléfono a 10 dígitos"></textarea>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>&nbsp;&nbsp; * Correo electrónico</mat-label>
          <textarea matInput formControlName="email"></textarea>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>* Medio por el cual se entero del CONOCER</mat-label>
          <mat-select formControlName="medios">
            <mat-option *ngFor="let medio of mediosConocer" [value]="medio.id">{{medio.descripcion}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <input matInput  [matDatepicker]="picker" [matDatepickerFilter]="myFilter" [min]="minDate"
            (dateChange)="onChange()" placeholder="&nbsp;&nbsp;* Seleccione una fecha presionando el icono del calendario ubicado en el extremo derecho " formControlName="picker" disabled>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker disabled="false"></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>* Seleccione la hora de la videollamada</mat-label>
          <mat-select formControlName="hora">
            <mat-option *ngFor="let hora of horas" [value]="hora.id">{{hora.descripcion}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="full-width">
          <mat-label>&nbsp; * Describa a detalle su solicitud</mat-label>
          <textarea matInput formControlName="descripcion"></textarea>
        </mat-form-field>
        <br>
        <section class="section">
          <mat-checkbox  color="primary" class="margin"  formControlName="terminos" (click)="onclick()">He leído y acepto los términos y condiciones de uso </mat-checkbox>
        </section>
        <br>        
        <div style="width: 100%; text-align: center">
          <mat-card-actions>
            <button mat-raised-button type="submit" color="primary" [disabled]="!formulario.valid">Realizar
              Cita</button>
          </mat-card-actions>
        </div>
      </form>
    </div>
  </div>
</div>